import * as React from 'react';

import { Carousel, cn } from '@rematter/ui-web';

type FileRecord = {
  id: string;
  fileName: string;
  path?: string;
  mimeType: string;
};

type ImageCarouselProps = {
  files: FileRecord[];
  className?: string;
};

//
// ⚛️ ⚛️ ⚛️ IMAGE CAROUSEL ⚛️ ⚛️ ⚛️
//
export const ImageCarousel = ({ files, className }: ImageCarouselProps) => {
  const imageFiles = React.useMemo(
    () => files.filter((f) => f.mimeType.startsWith('image/')),
    [files],
  );

  if (imageFiles.length === 0) {
    return null;
  }

  return (
    <Carousel className={cn('@ImageCarousel', className)} arrowSize={16}>
      {imageFiles.map((file) => (
        <img
          key={file.id}
          src={file.path}
          alt={file.fileName}
          className="h-full w-full object-cover"
        />
      ))}
    </Carousel>
  );
};
